/* global require */

require('./core/alert-manager.js');
require('./core/announcements.js');
require('./core/file.js');
require('./core/font-awesome.js');
require('./core/global.js');
require('./core/modal-global.js');
require('./core/sidebar.js');
require('./custom/jquery.html5-placeholder-shim.js');
require('./module/timetable/eventdetails.js');
require('./module/timetable/jquery.timetable.js');
require('./views/absences/accesscontrol.js');
require('./views/absences/index.js');
require('./views/absences/reporting.js');
require('./views/attendances/index.js');
require('./views/attendances/nonattendance.js');
require('./views/choices/index.js');
require('./views/choices/report.js');
require('./views/classreps/index.js');
require('./views/communications/index.js');
require('./views/curriculum-resources/index.js');
require('./views/curriculum-resources/manage-permissions.js');
require('./views/eportfolio/assignments.js');
require('./views/eportfolio/groups.js');
require('./views/eportfolio/myexperiences.js');
require('./views/eportfolio/myfiles.js');
require('./views/eportfolio/mypersonalfiles.js');
require('./views/eportfolio/students-report.js');
require('./views/eportfolio/submissions.js');
require('./views/eportfolio/submissions-report.js');
require('./views/help/reportaconcernform.js');
require('./views/help/requestsupportappointment.js');
require('./views/home/index.js');
require('./views/intercalating/apply.js');
require('./views/outcomes/index.js');
require('./views/pages/addeditresource.js');
require('./views/pages/addeditsection.js');
require('./views/pages/index.js');
require('./views/pages/manageresources.js');
require('./views/pages/viewpage.js');
require('./views/placements/grid.js');
require('./views/placements/managedates.js');
require('./views/placements/manageplacements.js');
require('./views/placements/studentallocations.js');
require('./views/placements/totals.js');
require('./views/regents/index.js');
require('./views/reporting/studentevents.js');
require('./views/reporting/studentfeedback.js');
require('./views/reporting/studentplacements.js');
require('./views/resources/manager.js');
require('./views/session/login.js');
require('./views/timetable/categories.js');
require('./views/timetable/index.js');
require('./views/timetable/rollover.js');
require('./views/weeklyresources/manager.js');
require('./views/yr4/admin.js');
require('./views/yr4/editcasebasedlearning.js');
require('./views/yr4/edittutor.js');
require('./views/yr4/eportfolio.js');
require('./views/yr4/extensions.js');
require('./views/yr4/gpavailability.js');
require('./views/yr4/index.js');
require('./views/yr4/managespecialities.js');
require('./views/yr4/section.js');
require('./views/yr4/studentallocations.js');
require('./views/yr5/index.js');
require('./views/yr5/managespaces.js');
require('./views/yr5/managesubmissiondates.js');
require('./views/yr5/placements.js');
